'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	return typeof String.prototype.padEnd === 'function' ? String.prototype.padEnd : implementation;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/string.prototype.padend/polyfill.js
// module id = 281
// module chunks = 0